import { render, staticRenderFns } from "./SuccessProp2.vue?vue&type=template&id=36ea9e82&"
import script from "./SuccessProp2.vue?vue&type=script&lang=js&"
export * from "./SuccessProp2.vue?vue&type=script&lang=js&"
import style0 from "./SuccessProp2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports